export default __webpack_public_path__ + "static/media/contra-reversed-icon.20f6e1f6.svg";